module.exports = __webpack_public_path__ + "img/banner_desktop.3a48625c.jpg";